// src/layouts/CustomLoginPage.js
import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useLogin, useNotify } from "react-admin";

import comfortLogo from "../assets/logo-comfort.png";
import loliaLogo from "../assets/logo-lolia.png";

export default function CustomLoginPage() {
  const login = useLogin();
  const notify = useNotify();

  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(form);
    } catch (err) {
      notify("Invalid email or password", { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #08131f 0%, #131c2b 100%)",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          width: 440,
          padding: "36px 34px 42px",
          borderRadius: "16px",
          textAlign: "center",
          background: "rgba(255, 255, 255, 0.92)",
          backdropFilter: "blur(14px)",
          border: "1px solid rgba(255,255,255,0.4)",
          boxShadow: "0px 12px 32px rgba(0,0,0,0.25)",
        }}
      >
        {/* LOGOS ROW — BALANCED */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 3,
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              height: 60,
              width: 140,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={comfortLogo}
              alt="Comfort Line"
              style={{
                maxHeight: "55px",
                maxWidth: "130px",
                objectFit: "contain",
              }}
            />
          </Box>

          <Box
            sx={{
              height: 60,
              width: 140,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={loliaLogo}
              alt="Lolia Limousine"
              style={{
                maxHeight: "55px",
                maxWidth: "130px",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {/* TITLE */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#0f172a",
            fontSize: "1.3rem",
            mb: 0.5,
          }}
        >
          Accounts & Operations Dashboard
        </Typography>

        {/* SUBTITLE */}
        <Typography variant="body2" sx={{ mb: 3, color: "#475569" }}>
          Login to continue
        </Typography>

        {/* FORM */}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            name="username"
            fullWidth
            variant="outlined"
            size="small"
            value={form.username}
            onChange={handleChange}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          />

          <TextField
            label="Password"
            name="password"
            type="password"
            fullWidth
            variant="outlined"
            size="small"
            value={form.password}
            onChange={handleChange}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              py: 1.3,
              fontWeight: 600,
              fontSize: "0.95rem",
              borderRadius: "10px",
              background:
                "linear-gradient(90deg, #4f46e5 0%, #6d28d9 50%, #7c3aed 100%)",
              boxShadow: "0px 3px 10px rgba(99,102,241,0.4)",
              "&:hover": {
                background:
                  "linear-gradient(90deg, #4338ca 0%, #5b21b6 100%)",
              },
            }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : "LOGIN"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
